<template>
    <div class="project">
        {{ name }}<br>
        {{ description }}<br>
        {{ live }}<br>
        {{ code }}
        <br>
    
    </div>
</template>
<script>
export default{
    props:{
        image: File,
        name: String,
        description: String,
        live: String,
        code: String
    },
 
}
</script>